import TransitionalRegion from "components/TransitionalRegion";
import ACCOUNT_FEATURE from "enums/ACCOUNT_FEATURE";
import useGetProjectFeatures from "hooks/api/useGetProjectFeatures";
import useProject from "hooks/useProject";
import { Navigate, Outlet } from "react-router-dom";

interface Props {
  featureName: ACCOUNT_FEATURE;
}

export default function FeatureGuardLogic({ featureName }: Props) {
  const { projectId } = useProject();
  const { features, isLoading } = useGetProjectFeatures(projectId);

  if (isLoading) {
    return <TransitionalRegion showSpinner noResultsText={<></>} />;
  }

  const hasFeature = features.some((f) => f.featureName === featureName);
  if (!hasFeature) {
    return <Navigate to="/not-found" replace />;
  }

  return <Outlet />;
}
